/**
 * Does a Wi-Fi name read as a router's 5 GHz band?
 *
 * Routers that split their bands usually name the second one with a "5G" or
 * "5GHz" suffix: "Area42_5G", "Home 5G", "TDC-1234 5GHz". The connectors in
 * the kit are 2.4 GHz only, so one configured with such a name can never join
 * and sits in its own access point forever. Beta Test House 10 shipped that
 * way, typed into the staff Wi-Fi field with nothing to catch it.
 *
 * Deliberately a suffix rule and nothing cleverer. "5Guys" and "Home5Gaming"
 * are ordinary names, and a false alarm sends someone chasing a network that
 * is fine. The same rule lives on the backend in network_diagnosis.py.
 */
const FIVE_GHZ_SUFFIX = /[\s_-]?5\s*g(?:hz)?$/i;

export function looksLike5GhzSsid(name: string | null | undefined): boolean {
  if (!name) {
    return false;
  }
  return FIVE_GHZ_SUFFIX.test(name.trim());
}
